export default __webpack_public_path__ + "static/media/icon_7.65df7b2e.png";